import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleEditResourceDetailsConfigurationRequest(
  state: State,
  { planzone }: Boundaries["editResourceDetailsConfiguration"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToPending() }];
}

function handleEditResourceDetailsConfigurationSuccess(
  state: State,
  { planzone }: Boundaries["editResourceDetailsConfiguration"]["success"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToSuccess() }];
}

function handleEditResourceDetailsConfigurationFailure(
  state: State,
  { planzone }: Boundaries["editResourceDetailsConfiguration"]["failure"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { planzone, request: setRequestStateToFailure() }];
}

const reduceState = createStateReducer(initialState, {
  [events.editResourceDetailsConfigurationRequested]:
    handleEditResourceDetailsConfigurationRequest,
  [events.editResourceDetailsConfigurationSucceeded]:
    handleEditResourceDetailsConfigurationSuccess,
  [events.editResourceDetailsConfigurationFailed]:
    handleEditResourceDetailsConfigurationFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
